import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import Authentication from '../../session';
import { connect } from 'react-redux';
import './styles.scss';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { BasicLazyParams } from '../../utile';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';
import { Toast } from 'primereact/toast';
import Service from '../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import * as XLSX from 'xlsx';
import { Button } from 'primereact/button';
import moment from 'moment';

class RouteUtilizationReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            filteredInfo: [],
            lazyParams: BasicLazyParams,
            totalRecords: 0,
            routes: [],
            selectedRoute: null,
            services: [],
            selectedServices: [],
            serviceInfo: [],
        };
        this.service = new Service();
        this.toast = React.createRef();
    }

    fetchRouteUtilization = () => {
        const url = `${baseUrlAdmin}/transportReport/route-utilization-report`;
        this.setState({ isLoading: true });
        let payload = {
            academicYear: localStorage.getItem('userAcademicYear'),
        }
        this.service.post(url, payload, true)
            .then(res => {
                if (res?.status && res?.res?.data?.status) {
                    const routeInfo = res?.res?.data?.data.Routes;
                    const serviceInfo = res?.res?.data?.data.serviceInfo;
                    const { rows, first } = this.state.lazyParams;

                    this.setState({
                        routes: routeInfo.map(route => ({
                            value: route._id,
                            label: `${route.routeNo} - ${route.routeName}`,
                        })),
                        services: serviceInfo.map(service => ({
                            value: service._id,
                            label: service.serviceName,
                        })),
                        serviceInfo,
                        filteredInfo: serviceInfo,
                        totalRecords: serviceInfo.length,
                        isLoading: false
                    });
                    this.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Data fetched successfully', life: 3000 });
                } else {
                    this.setState({ isLoading: false });
                    this.toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data', life: 3000 });
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({ isLoading: false });
                this.toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data', life: 3000 });
            });
    }

    handleRouteChange = (e) => {
        const selectedRoute = this.state.routes.filter(route => e.value.includes(route.value));
        let filteredData = [...this.state.serviceInfo];
        let availableServices = [];

        if (e.value && e.value.length > 0) {
            filteredData = filteredData.filter(service =>
                e.value.includes(service.routeId)
            );

            const uniqueServicesMap = new Map();
            filteredData.forEach(service => {
                uniqueServicesMap.set(service._id, {
                    value: service._id,
                    label: service.serviceName
                });
            });
            availableServices = Array.from(uniqueServicesMap.values());
        }

        const { rows } = this.state.lazyParams;

        this.setState({
            selectedRoute: e.value,
            services: availableServices,
            selectedServices: [],
            filteredInfo: filteredData,
            totalRecords: filteredData.length,
            lazyParams: { ...this.state.lazyParams, first: 0 }
        });
    }

    handleServiceChange = (e) => {
        const selectedServices = e.value;
        let filteredData = [...this.state.serviceInfo];

        if (this.state.selectedRoute && this.state.selectedRoute.length > 0) {
            filteredData = filteredData.filter(service =>
                this.state.selectedRoute.includes(service.routeId)
            );
        }

        if (selectedServices && selectedServices.length > 0) {
            filteredData = filteredData.filter(service =>
                selectedServices.includes(service._id)
            );
        }

        this.setState({
            selectedServices: selectedServices,
            filteredInfo: filteredData,
            totalRecords: filteredData.length,
            lazyParams: { ...this.state.lazyParams, first: 0 }
        });
    }

    onPage = (event) => {
        const { first, rows } = event;
        let filteredData = [...this.state.serviceInfo];

        if (this.state.selectedRoute && this.state.selectedRoute.length > 0) {
            filteredData = filteredData.filter(service =>
                this.state.selectedRoute.includes(service.routeId)
            );
        }

        if (this.state.selectedServices && this.state.selectedServices.length > 0) {
            filteredData = filteredData.filter(service =>
                this.state.selectedServices.includes(service._id)
            );
        }

        this.setState({
            lazyParams: { ...this.state.lazyParams, first, rows },
            filteredInfo: filteredData.slice(first, first + rows)
        });
    }

    exportToExcel = () => {
        let filteredData = [...this.state.serviceInfo];

        // Apply route filter
        if (this.state.selectedRoute && this.state.selectedRoute.length > 0) {
            filteredData = filteredData.filter(service =>
                this.state.selectedRoute.includes(service.routeId)
            );
        }

        // Apply service filter
        if (this.state.selectedServices && this.state.selectedServices.length > 0) {
            filteredData = filteredData.filter(service =>
                this.state.selectedServices.includes(service._id)
            );
        }

        // Format data for export
        const exportData = filteredData.map(service => ({
            'Service Name': service.serviceName,
            'Route Name': service.routeName,
            'Vehicle Number': service.vehicleRegistrationNo,
            'Vehicle Type': service.vehicleType,
            'Vehicle Name': service.vehicleName,
            'Vehicle Owned': service.vehicleCategory,
            'GPS': service.isGps,
            'Seating Capacity': service.seatingCapacity,
            'Allotted Students': service.assignedCapacity,
            'Utilization %': Math.round(((service.assignedCapacity || 0) / (service.seatingCapacity || 0)) * 100) + '%'
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Service Utilization");

        // Generate and download file
        XLSX.writeFile(workbook, `Service_Utilization_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
    }

    componentDidMount() {
        this.fetchRouteUtilization();
    }

    render() {
        const containerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
            overflow: 'auto',
            transition: 'padding 0.3s',
            paddingBottom: '30px',
        };
        return (
            <>
                <div style={containerStyle} className='m-2'>
                    <div className="card filters-card mt-1 pt-0">
                        <div className="grid">
                            <div className='col-3'>
                                <p className='filter-title'>Routes</p>
                                <ClassetMultiSelect
                                    options={this.state.routes}
                                    value={this.state.selectedRoute}
                                    optionLabel='label'
                                    onChange={this.handleRouteChange}
                                    placeholder="Select Route"
                                    tooltip={null}
                                    showTooltip={false}
                                    tooltipOptions={{ disabled: true }}
                                />
                            </div>
                            <div className='col-3'>
                                <p className='filter-title'>Services</p>
                                <ClassetMultiSelect
                                    options={this.state.services}
                                    value={this.state.selectedServices}
                                    optionLabel='label'
                                    onChange={this.handleServiceChange}
                                    placeholder="Select Service"
                                    tooltip={null}
                                    showTooltip={false}
                                    tooltipOptions={{ disabled: true }}
                                    disabled={!this.state.selectedRoute}
                                />
                            </div>
                            <div className="col-3 mt-5 flex justify-content-end align-items-center gap-5 ms-auto" style={{ maxWidth: 'fit-content' }}>
                                <Button
                                    label="Download Report"
                                    onClick={this.exportToExcel}
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                                />
                                <Button label="View Analysis" className="p-button-primary"
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff", }} />
                            </div>

                        </div>
                    </div>
                    <div className="datatable-report-demo mx-2">
                        <DataTable
                            value={this.state.filteredInfo}
                            responsiveLayout="scroll"
                            dataKey="id"
                            paginator
                            lazy
                            onPage={this.onPage}
                            resizableColumns
                            first={this.state.lazyParams.first}
                            last={this.state.totalRecords}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                            rowClassName={() => 'table-row-style'}
                        >
                            <Column header="Service Name" field='serviceName'></Column>
                            <Column header="Route Name" field='routeName'></Column>
                            <Column header="Vehicle Number" field='vehicleRegistrationNo'></Column>
                            <Column header="Vehicle Type" field='vehicleType'></Column>
                            <Column header="Vehicle Name" field='vehicleName'></Column>
                            <Column header="Vehicle Owned" field='vehicleCategory'></Column>
                            <Column header="GPS" field='isGps'></Column>
                            <Column header="Seating Cap" field='seatingCapacity'></Column>
                            <Column header="Allotted Students" field='assignedCapacity' body={(rowData) => {
                                return (
                                    <div className="text-center">
                                        {rowData.assignedCapacity || 0}
                                    </div>
                                );
                            }}></Column>
                            <Column
                                header="Utilization %"
                                body={(rowData) => {
                                    const utilizationPercentage = Math.round(((rowData.assignedCapacity || 0) / (rowData.seatingCapacity || 0)) * 100);
                                    console.log("Utilization Percentage: ", utilizationPercentage);
                                    const color = utilizationPercentage > 70 ? '#4CAF50' : '#ff4444';
                                    return (
                                        <div style={{ color: color, fontWeight: 'bold' }}>
                                            {utilizationPercentage}%
                                        </div>
                                    );
                                }}
                            ></Column>
                        </DataTable>
                    </div>
                </div>
                <Toast ref={this.toast} position="bottom-right" />
                {
                    this.state.isLoading && <LoadingComponent />
                }
            </>

        )
    }
}
const mapStatesToProps = (state) => ({
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
});
export default connect(mapStatesToProps, {})(Authentication(withRouter(RouteUtilizationReport)));
